import 'babel-polyfill';
import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import {Router, Route, useRouterHistory} from 'react-router';
import {createHistory} from 'history';
import {Provider} from 'mobx-react';
import {I18nextProvider} from 'react-i18next';
import {wixAxiosConfig} from 'wix-axios-config';
// import App from './components/App';
import i18n from './i18n';

// CONTAINERS
import Intro from './containers/Intro';
import Main from './containers/Main';
import {Modifiers, GettingStarted, Presets, ComponentPage, ThemeManager} from './components';
// STYLES
import './styles/app.scss';
import './styles/_vars.scss';

// STORE
import stores from './stores';
import {docsActions} from './actions';

const baseUrl = window.__BASEURL__;
const locale = window.__LOCALE__;
const staticsBaseUrl = window.__STATICS_BASE_URL__;

const history = useRouterHistory(createHistory)({
  basename: baseUrl.replace(/\/$/, '')
});

wixAxiosConfig(axios, {baseURL: baseUrl});

ReactDOM.render(
  <Provider {...stores}>
    <I18nextProvider i18n={i18n({locale, baseUrl: staticsBaseUrl})}>
      <Router history={history}>
        <Route path="/" component={Intro}/>
        <Route path="/docs" component={Main}>
          <Route path="/docs/modifiers" component={Modifiers}/>
          <Route path="/docs/getting-started" component={GettingStarted}/>
          <Route path="/docs/presets" component={Presets}/>
          <Route path="/docs/theme-manager" component={ThemeManager}/>
          <Route path="/docs/:componentId" component={ComponentPage}/>
        </Route>
      </Router>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

docsActions.fetchDocs();



// WEBPACK FOOTER //
// ./client.js